export default "/loader-straight.a106d60e999777c080003539155d4b99.svg";